import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const programContent = [
  {
    name: "Weight Lifting",
    description:
      "Wimply dummy text of the printing and typesetting industryrem Ipsum has been ttandard dummy.",
    img:
      "https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2017/05/gym-icon-1.png",
  },
  {
    name: "Body Building",
    description:
      "Wimply dummy text of the printing and typesetting industryrem Ipsum has been ttandard dummy.",
    img:
      "https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2017/05/gym-icon-2.png",
  },
  {
    name: "Cycling",
    description:
      "Wimply dummy text of the printing and typesetting industryrem Ipsum has been ttandard dummy.",
    img:
      "https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2017/05/gym-icon-3.png",
  },
  {
    name: "Yoga",
    description:
      "Wimply dummy text of the printing and typesetting industryrem Ipsum has been ttandard dummy.",
    img:
      "https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2017/05/gym-icon-4.png",
  },
];

const Workout = () => {
  return (
    <Container className="mx-auto">
      <Row className="align-items-center justify-content-center">
        <div className="text-center">
          <h2>
            <span
              style={{
                fontSize: "32px",
                color: "#111111",
                fontWeight: "600",
                lineHeight: "1.2",
              }}
            >
              OUR PROGRAM
            </span>
          </h2>
          <p className="my-4 p-4 w-75 mx-auto">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor quasi
            deserunt error ipsum? Aut, corrupti?
          </p>
        </div>
        <Col xs={12} md={6}>
          <section className="row">
            {programContent.map((data, i) => {
              return (
                <div className="col-12 col-md-6">
                  <img className="img-fluid" src={data?.img} alt="ico" />
                  <h4 className="my-3">{data?.name}</h4>
                  <p style={{ lineHeight: "1.7rem" }}>{data?.description}</p>
                </div>
              );
            })}
          </section>
        </Col>
        <Col xs={12} md={6} className="align-self-center">
          <img
            className="img-fluid"
            src="https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2016/10/being-builder.png"
            alt="body"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Workout;
